import { badgeStylesOverride } from "../components/badge/styles.es.js";
import { dialogStyleOverrides } from "../components/dialog/styles/dialog.es.js";
import { radioStylesOverride } from "../components/radio/styles.es.js";
import { textFieldStyleOverrides } from "../components/text-field/styles.es.js";
import { toolTipStyleOverrides } from "../components/tooltip/styles/tooltip.es.js";
import { palette } from "./palette.es.js";
import { typography } from "./typography.es.js";
import "../style.css.es.js";
import { createTheme } from "@mui/material";
import { buttonStyleOverrides } from "../components/button/styles.es.js";
import { inputStyleOverrides } from "../components/input/styles.es.js";
import { listItemButtonOverrides } from "../components/sidebar/styles.es.js";
import { chipStyleOverrides } from "../components/chip/styles.es.js";
import { paperStyleOverrides } from "../components/paper/styles.es.js";
import { alertStylesOverride } from "../components/alert/styles.es.js";
import { alertDefaultProps } from "../components/alert/default-props.es.js";
import { alertTitleStylesOverride } from "../components/alert-title/styles.es.js";
import { accordionStyleOverrides } from "../components/accordion/styles/accordion.es.js";
import { accordionSummaryStyleOverrides } from "../components/accordion/styles/accordion-summary.es.js";
import { accordionDetailsStyleOverrides } from "../components/accordion/styles/accordion-details.es.js";
import { iconButtonStyleOverrides } from "../components/icon-button/styles.es.js";
import { checkboxStylesOverride } from "../components/checkbox/styles.es.js";
import { switchStylesOverride } from "../components/switch/styles.es.js";
import { dialogTitleStylesOverrides } from "../components/dialog-title/styles.es.js";
import { dialogContentStylesOverrides } from "../components/dialog-content/styles.es.js";
import { dialogActionsStylesOverrides } from "../components/dialog-actions/styles.es.js";
import { linearProgressStylesOverride } from "../components/linear-progress/styles.es.js";
import { menuItemStylesOverrides } from "../components/menu-item/styles.es.js";
const theme = createTheme({
  palette,
  typography,
  spacing: 4,
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: buttonStyleOverrides
    },
    MuiOutlinedInput: {
      styleOverrides: inputStyleOverrides
    },
    MuiListItemButton: {
      styleOverrides: listItemButtonOverrides
    },
    MuiChip: {
      styleOverrides: chipStyleOverrides
    },
    MuiPaper: {
      styleOverrides: paperStyleOverrides
    },
    MuiAlert: {
      styleOverrides: alertStylesOverride,
      defaultProps: alertDefaultProps
    },
    MuiAlertTitle: {
      styleOverrides: alertTitleStylesOverride
    },
    MuiAccordion: {
      styleOverrides: accordionStyleOverrides
    },
    MuiAccordionSummary: {
      styleOverrides: accordionSummaryStyleOverrides
    },
    MuiAccordionDetails: {
      styleOverrides: accordionDetailsStyleOverrides
    },
    MuiIconButton: {
      styleOverrides: iconButtonStyleOverrides
    },
    MuiCheckbox: {
      styleOverrides: checkboxStylesOverride
    },
    MuiSwitch: {
      styleOverrides: switchStylesOverride
    },
    MuiRadio: {
      styleOverrides: radioStylesOverride
    },
    MuiDialog: {
      styleOverrides: dialogStyleOverrides
    },
    MuiDialogTitle: {
      styleOverrides: dialogTitleStylesOverrides
    },
    MuiDialogContent: {
      styleOverrides: dialogContentStylesOverrides
    },
    MuiDialogActions: {
      styleOverrides: dialogActionsStylesOverrides
    },
    MuiTextField: {
      styleOverrides: textFieldStyleOverrides
    },
    MuiTooltip: {
      styleOverrides: toolTipStyleOverrides
    },
    MuiLinearProgress: {
      styleOverrides: linearProgressStylesOverride
    },
    MuiMenuItem: {
      styleOverrides: menuItemStylesOverrides
    },
    MuiBadge: {
      styleOverrides: badgeStylesOverride
    }
  }
});
export {
  theme
};
//# sourceMappingURL=theme.es.js.map
